var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChatRead = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19412"
}, /*#__PURE__*/React.createElement("g", {
  fill: "none",
  "data-name": "Group 19410"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "data-name": "Group 12122"
}, /*#__PURE__*/React.createElement("path", {
  d: "m2 7.504 2.7 3.121 5.623-5.626",
  "data-name": "Path 6069"
}), /*#__PURE__*/React.createElement("path", {
  d: "m6 7.504 2.7 3.121 5.623-5.626",
  "data-name": "Path 6070"
})), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h16v16H0z",
  "data-name": "Rectangle 7591"
})))));
export { SvgChatRead as ReactComponent };
export default __webpack_public_path__ + "static/media/chat_read.1e4228d874d27880e6701f8b8f8e5bec.svg";